import React from 'react';
import './ServiceDontia.css';
import Contact from "../Pages/Contact";
import { Link } from 'react-router-dom'; // Import Link from react-router-dom

import { Container, Row, Col, Card } from 'react-bootstrap';

const ServicesKinitikiComponent = () => {
  return (
    <div>
    <Container className="services-container">
      <h2 className="mt-5 mb-4">Κινητή Προσθετική</h2>
      <Row>
        <Col md={4} className="mb-4">
          <Card className="service-card">
            <Card.Body>
              <Card.Title className="card-title"> <Link to="/dental-clinic/teeth-merikiodontostixia">Μερικές οδοντοστοιχίες</Link> {/* Hash link */}</Card.Title>
              <Card.Text className="card-text">
              Οι μερικές οδοντοστοιχίες είναι τα γνωστά σε όλους «μηχανάκια» ή «μασελάκια».
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4} className="mb-4">
          <Card className="service-card">
            <Card.Body>
              <Card.Title className="card-title"> <Link to="/dental-clinic/teeth-olikiodontostixia">Ολικές οδοντοστοιχίες</Link> {/* Hash link */}</Card.Title>
              <Card.Text className="card-text">
              Η ολική οδοντοστοιχία ή αλλιώς μασέλα (γνωστή σε όλους μας!) 
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
       
        
       
    
       
      </Row>
    </Container>

    <Contact /> {/* Contact component */}
    </div>
    
  );

  
};



export default ServicesKinitikiComponent;